export const WecAiSchedulersFeatureName = 'WecAiSchedulers'